/**
 * Per-category in-assessment help for the persona questionnaire (Help System Phase 4).
 * Plain end-user language (jargon-light), de-jargoned from the Phase 2 HelpCenter
 * "360 Family" section. Self-contained — no /help link (locked personas can't reach /help).
 * company_profile is intentionally absent (profile questions are self-evident).
 */
export const questionCategoryHelp = {
  c360: {
    title: 'Cybersecurity posture',
    blurb:
      "These questions gauge your core cybersecurity posture — the technology, operations, and third-party safeguards that protect the organization day to day.",
  },
  d360: {
    title: 'Data handling',
    blurb:
      "These questions look at how you handle sensitive and regulated data — how it's classified, where it lives, and who can access it.",
  },
  p360: {
    title: 'People & culture',
    blurb:
      'These questions focus on the human side — training, awareness, role clarity, and insider risk.',
  },
  e360: {
    title: 'Institutional & technical debt',
    blurb:
      "These questions surface 'debt' that drives future cost — unresolved policy and process gaps, plus aging or deferred technology.",
  },
  cyber_insurance: {
    title: 'Cyber-insurance readiness',
    blurb:
      'These questions check your cyber-insurance readiness — your coverage and the security controls insurers increasingly expect.',
  },
};

/**
 * Resolve a question's `category` to a help entry.
 * Strips the `_header` suffix (section-divider rows share their dimension's help)
 * and returns null when there is no entry (e.g. company_profile) so callers omit the icon.
 */
export function getCategoryHelp(category) {
  if (!category) return null;
  const base = String(category).replace(/_header$/, '');
  return questionCategoryHelp[base] || null;
}
